const RequiredContextValue = require("../classes/required-context-value");

function isPlainObject(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

function entityContextFromBinding(binding) {
  return {
    entityType: String(binding.entityType ?? "").split(".").at(-1),
    entityPkUrlVars: binding.entityPkVars ?? binding.entityPkUrlVars ?? {},
    entitySource: binding.entitySource,
    appName: binding.appName ?? null,
  };
}

function entityScopeFromBindings({ bindings, required, lookupSourceContext }) {
  const source = isPlainObject(bindings) ? bindings : {};
  const scoped = {};
  Object.entries(source).forEach(([requiredName, binding]) => {
    if (RequiredContextValue.isEntityBinding(binding)) {
      scoped[requiredName] = entityContextFromBinding(binding);
    }
  });
  Object.keys(isPlainObject(required) ? required : {}).forEach(requiredName => {
    if (scoped[requiredName] !== undefined) {
      return;
    }
    const binding = source[requiredName];
    if (typeof binding !== "string" || !binding) {
      return;
    }
    const available = lookupSourceContext(binding);
    if (available) {
      scoped[requiredName] = available;
    }
  });
  return scoped;
}

function primitiveScopeFromBindings({ bindings, contexts, readEntityField }) {
  const resolved = {};
  Object.entries(isPlainObject(bindings) ? bindings : {}).forEach(([name, binding]) => {
    if (!RequiredContextValue.isPrimitiveBinding(binding)) {
      return;
    }
    const { value } = RequiredContextValue.resolve(binding, { contexts, readEntityField });
    if (value !== undefined) {
      resolved[name] = value;
    }
  });
  return resolved;
}

module.exports = { entityScopeFromBindings, primitiveScopeFromBindings };
